const lan = {
  REDIRECT: "Redirection...",
  RULE: {
    SERVICE_TYPE: "Veuillez sélectionner un service.",
    COUNTRY: "Veuillez sélectionner un pays ou une région",
    USERNAME: "Un nom d'utilisateur est demandé",
    EMAIL: "Une adresse e-mail est requise",
    EMAIL2: "Veuillez entrer le format d'email correct.",
    PRODUCT: "Merci de sélectionner votre produit",
    PRODUCTSN: "Merci de saisir le numéro de série de votre produit",
    PRODUCTSN_LEN: "Veuillez saisir entre 12 et 15 lettres ou chiffres",
    BIRTHDAY: "Une date d'anniversaire est requise",
    REQUIRED: "Nécessaire",
  },
  SYS: {
    HEAD: "Système",
    NOSERVICE:
      "Désolé, le service tchat d'ASUS n'est pas disponible pour le pays ou la région sélectionné.",
    CHECK_FILESIZE:
      "Veuillez vérifier la taille de l'image ou du fichier ci-joint. Limite : ",
    RECONNECTED: "La connexion est rétablie",
    UNABLE_SEND: "Il est impossible d'envoyer les pièces ci jointes",
    NO_NETWORK: "Pas de connexion internet",
    NO_NETWORK_INFO:
      "Aucune connexion internet. Merci de vous connecter à réseau internet et de réessayer par la suite.",
  },
  IDLE: {
    HEAD:
      "Vous êtes inactif depuis un moment. Souhaitez-vous continuer le tchat ?",
    BUTTON: "Continuer",
  },
  DISCONNECT: {
    HEAD: "Le tchat est terminé",
    BUTTON: "Fin",
  },
  LAYOUT: {
    STEP_1: "Sélectionner un produit",
    STEP_2: "Conditions de Service",
    STEP_3: "Connexion",
    STEP_4: "Information",
    SELECT_SKILL: "Sélectionner un produit",
    PREV_STEP: "Précédent",
    NEXT_STEP: "Suivant",
    NOTSET: "Non défini.",
    AGREEN: "Accepter",
    NOTAGREEN: "Refuser",
    LEAVE: "Quitter",
    TYPE_HERE: "Écrivez ici",
    CHAT_DOWNLOAD:
      "Veuillez cliquer ici afin d'enregistrer une copie des échanges avec le service tchat d'ASUS.",
  },
  COUNTRY: {
    SELECT_COUNTRY: "Veuillez sélectionner le pays ou la région du service",
  },
  POLICY: {
    PRIVACY: "Politique relative à la protection des données personnelles",
    SAT_SURVEY: "Enquête de satisfaction",
    CONFIRM_COUNTRY: {
      H1: "Cher(e) client(e) ASUS,",
      P1:
        "Vous visitez maintenant le service à la clientèle en ligne d'ASUS, qui est différent de votre région . Selon les conditions de garantie d'ASUS, tous les produits ASUS ne sont pas éligibles au service de garantie et d'assistance international d'ASUS. Si le site régional ci-dessus que vous visitez n'est pas la région où vous avez acheté votre produit ASUS ou est différent de votre région actuelle, cela peut affecter vos droits. Vous pouvez continuer à utiliser le service clientèle en ligne d'ASUS ou changer le service pour une autre région.",
      P2: "",
      P3: "",
      B1: "Basculer vers ASUS",
      B2: "Site internet",
      B3: "Continuer à utiliser",
    },
    BULLETIN: {
      HEAD: "Notification d'un message important",
      CONFIRM: "J'ai compris",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Veuillez remplir vos coordonnées",
    SURVEY_TYPE: "Veuillez sélectionner le type de service",
    PROBLEM_BRIEF: "Comment décririez-vous votre problème ?",
    TYPE1: "Question générale",
    TYPE2: "Demande de réparation",
    TYPE3: "Assistance technique",
    TYPE4: "Demande de garantie",
    TYPE5: "Avis et commentaires",
    EC_TYPE1: "Informations sur les produits et services",
    EC_TYPE2: "Évènement Marketing",
    EC_TYPE3: "Statut de livraison et commande",
    EC_TYPE4: "Service de Retour",
    SIGNUPDATA: "Vos informations d'inscription",
    NAME: "Nom",
    TEL: "Numéro de téléphone",
    ORDER_NO: "Order No.",
    BIRTHDAY: "Date de naissance",
    LABEL_EMAIL: "Email",
    EMAIL: "E-mail",
    DEVICEINFO: "Les informations sur votre produit",
    DEVICENAME: "Nom du produit",
    MY_DEVICE: "Votre produit",
    MY_DEVICE_SELECT: "Select Your Product",
    MY_DEVICE_EMPTY: "You don't have any devices yet.",
    LABEL_DEVICESN: "Serial Number",
    DEVICESN: "Numéro de série du produit",
    DEVICESN_ERROR: "Le numéro de série que vous avez entré est invalide.",
    PREPARE: "Création du Salon de Discussion, préparez-vous au tchat",
    START: "Commencer le tchat",
    AGE_LIMIT: "Limite d'âge",
    AGE_LIMIT_DESC:
      "Vous ne répondez pas aux critères d'âge pour utiliser le service tchat d'ASUS",
    REPEAT_ENTRY: {
      H1: "Détection d'un salon de discussion existant",
      P1:
        "Êtes-vous sûr de vouloir démarrer une nouvelle conversation ? Lorsqu'une nouvelle conversation est ouverte, l'ancienne conversation sera clôturée.",
      B0: "Confirmer",
      B1: "Annuler",
    },
  },
  CONNECTTING: {
    P1:
      "Veuillez patienter un instant s'il vous plaît, et ne fermez pas la fenêtre de discussion",
    P2:
      "Le service tchat d'ASUS est en train de vous connecter à un agent disponible",
    NOTE: "Indication",
    BEFORE_LEAVE: "Etes-vous sûr de vouloir terminer votre tchat ASUS ?",
    B0: "Fin",
    B1: "Patienter",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Contacter ASUS via d'autres canaux de communication",
    MAIL: "Nous contacter par e-mail",
    TEL: "Nous appeler",
    CLOSE: "Terminer",
  },
  WAITTING: {
    WATTING_NUM: "Position dans la file d'attente",
    PEOPLE: "Clients",
    NOTE: "Indication",
    BEFORE_LEAVEL: "Êtes-vous sûr de vouloir quitter la file d'attente ?",
    LEAVE_DESC:
      "Si vous souhaitez quitter la file d'attente, vous pouvez terminer le tchat",
    LEAVE: "Terminer le tchat",
    STAY: "Rester dans la file d'attente",
  },
  CHATROOM: {
    TYPING: "L'agent tchat est en train d'écrire...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Terminer le tchat",
      TERMINATE: "Terminer le tchat",
    },
    FOOTER: { CHAT_FINISH: "Le tchat est terminé" },
    FINISH:
      "Le tchat est terminé. Avez-vous besoin d'un service ou d'un support complémentaire ?",
    SAT_SURVEY: {
      SAT: "Satisfait(e)",
      DISSAT: "Non satisfait(e)",
      SAT_CHOOSE: "Quel type de service ? (Multiple)",
      HEAD: "Avez-vous été satisfait du service de messagerie en ligne ",
      DESC:
        "Consulter vos commentaires est essentiel à notre démarche d'amélioration continue. Si vous avez des suggestions pour ASUS Service ou Support, merci de nous en faire part.",
      OTHER_OPTION: "Autre",
      OTHER_REASON: "Veuillez renseigner l'autre raison",
      SEND: "Envoyer",
    },
    CLOSE: {
      TITLE: "Êtes-vous sûr de vouloir terminer le tchat ?",
      P1:
        'Cliquez sur "Terminer" pour fermer la fenêtre. Si vous avez besoin d\'utiliser à nouveau le tchat, veuillez cliquer sur "Commencer un nouveau tchat".',
      B0: "Terminer",
      B1: "Annuler",
    },
  },
  ERROR: {
    H1: "Le Salon de Discussion n'existe pas ou le tchat est déjà terminé",
    CLOSE: "Fermer la fenêtre",
  },
  CHAT_END: {
    H1: "Merci beaucoup, le tchat est maintenant terminé",
    CLOSE: "Fermer la fenêtre",
  },
  CHAT_CLOSE: {
    H1:
      "Votre réseau est déconnecté depuis plus de 300 secondes, nous avons donc terminé cette conversation.",
    DESC:
      "Si vous utilisez un réseau sans fil ou un réseau mobile, veuillez essayer de trouver un emplacement avec un meilleur signal ; ou basculer vers une connexion réseau câblée, désolé pour la gêne occasionnée",
    CLOSE: "Fermer la fenêtre",
  },
  SURVEY_DONE: {
    H1: "Merci d'avoir répondu à l'enquête de satisfaction !",
    P1:
      'Vos commentaires sont essentiels à notre demarche d\'amélioration continue. Merci d\'avoir pris le temps de compléter le questionnaire de satisfaction. Si vous avez besoin d\'un support supplémentaire, veuillez cliquer sur "Démarrer un nouveau tchat". Si nous avons résolu votre requête, veuillez cliquer sur "Fermer la fenêtre" pour finaliser le tchat',
    AGAIN: "Commencer un nouveau tchat",
    CLOSE: "Fermer la fenêtre",
    YT_H1:
      "Découvrez nos astuces et nos guides techniques avec les vidéos support ASUS.",
    YT_H2: "Cliquez ici pour découvrir !",
  },
  AGENT_OFFLINE: {
    H1:
      "Il semble y avoir un problème avec la connexion Internet, ce qui a interrompu votre session de chat pour le moment",
    H2:
      "Nous sommes en train de résoudre un problème technique qui affecte la connexion Internet de l'agent tchat. Veuillez patienter un instant et ne pas fermer la fenêtre, nous faisons tout notre possible pour rétablir le tchat dès que possible",
    DESC:
      'Vous pouvez également choisir de terminer la session pour compléter une enquête de satisfaction, ou cliquer sur "Démarrer un nouveau tchat", et nous assignerons immédiatement un nouvel agent pour poursuivre la session. Désolé pour la gêne occasionnée',
    AGAIN: "Commencer un nouveau tchat",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Impossible d'utiliser le micro et la caméra",
    H1: "Prêt à vous connecter ?",
    P1:
      "Pour que le notre équipe puisse vous aider à résoudre le problème plus efficacement, vous devez autoriser l'appareil à accéder à votre caméra et à votre microphone pour rejoindre la salle de chat vidéo. Veuillez également vous assurer que la connexion de votre réseau est stable et fonctionne normalement.",
    P2:
      "Arpès avoir donné l'accès, vous pourrez toujours librement couper votre caméra et votre micro.",
    VIDEO_STATE: "Satut vidéo",
    VIDEO_ON: "On",
    VIDEO_OFF: "Off",
    AUDIO_STATE: "Satut audio",
    AUDIO_ON: "On",
    AUDIO_OFF: "Off",
    ENTER: "Rejoindre",
    HANGUP: {
      H1: "Raccrocher",
      P1: "Souhaitez vous vraiment terminer le chat vidéo",
      CONFIRM: "Confirmer",
      CANCEL: "Annuler",
    },
    END: {
      H1: "Chat vidéo terminé",
      P1: "Merci, ce chat vidéo est terminé, vous pouvez fermer la fenêtre.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Sélectionner un produit",
      STEP_2: "Conditions de Service",
      STEP_3: "Connexion",
      STEP_4: "Information",
      SELECT_SKILL: "Sélectionner un produit",
      WELCOME: "Welcome",
      AGREE: "Accorder",
      START: "Commencer",
      CANCEL: "Annuler",
      WAIT: "Veuillez patienter",
      INPUT: "Saisir le texte",
      TRANSFER_TOAGENT: "Transfert à l'agent",
      READMORE: "Vous pouvez également vous référer à la FAQ suivante, merci.",
      COLLAPSE: "Réduire",
      INPUT_SN: "Veuillez de nouveau indiquer votre numéro de série",
      YOU_MAY_ALSO: "Vous pourriez aussi demander:",
      FOR_FURTHER: "Pour plus d'informations, se référer à:",
      RECORDING: "Veuillez commencer à enregistrer...",
      RECORDING_NOT_SUPPORTED:
        "Votre navigateur ne permet pas la reconnaissance vocale",
      RECORDING_NOT_FOUND:
        "Aucun enregistrement détecté. Veuillez verifier les paramètres de votre micro et les autorisations.",
    },
    IS_COMPONENT_SN:
      "Le champ de saisie est le numéro de série du composant, vous devez entrer le numéro de série correct de la machine.",
    WARRANTY: {
      SERIES: "Type de produit",
      MODEL: "Nom du produit",
      SERIALNO: "Numéro de série du produit",
      STATUS: "État de la garantie",
      DATE: "Date d'expiration de la garantie",
    },
    HEAD: {
      LEAVE: "Quitter",
      CREATE_NEW: "Créer une nouvelle salle de chat",
    },
    ENTRANCE: {
      POLICY: "Politique de confidentialité",
      AGREE: "Cliquez sur Accepter pour entamer la conversation",
    },
    MESSAGE: {
      WAIT: "Veuillez patienter, nous cherchons une solution pour vous.",
    },
    END: "Conversation Terminée",
    END_MSG: "Nous sommes heureux de vous aider. La conversation est terminée",
    END_SURVEY: "Enquête de satisfaction",
    END_SURVEY_MSG:
      "Nous sommes heureux de vous aider. La conversation est terminée",
    BACKHOME: "Retour à la page d'accueil",
    SURVEY: {
      DESC: "Veuillez noter votre expérience avec l'assistant virtuel ASUS.",
      SAT: "Satisfait",
      DISSAT: "Insatisfait",
      FEEDBACK: "Veuillez indiquer vos commentaires.",
      SEND: "Envoyer",
      BACK: "Annuler",
    },
    SURVEY_DISLIKE: {
      H1: "Pourquoi n'appréciez vous pas la réponse apportée?",
      P: "Vos retours nous aident à améliorer notre qualité de service.",
      BUTTON: "Envoyer",
    },
    HISTORY: {
      TITLE: "Historique",
      AGO: "{hours} il y a ",
      CONTINUE: "Continuer Chat",
      CLOSE: "La conversation est terminée.",
      RESTART: "Recommencer avec l'Assistant Virtuel",
      NON_SERVICE: "Hors des heures d'ouverture",
      VIEW_HISTORY: "Cliquer pour consulter l'historique de chat.",
    },
  },
};
export default lan;
